import * as React from "react";

import { ErrorBoundary } from "@/components/ErrorBoundary";
import { Restricted } from "@/components/Restricted";

import { RoleGroupsProvider } from "./RoleGroupContext";
import {
    AppsProvider,
    SMART_WIDGETS,
    useAppsContext,
    WIDGET_LABELS,
} from "./SmartAppsContext";
import { Widget } from "./Widget";

import "./RSEEditor.css";

const ALL_SMART_WIDGETS = [
    ...SMART_WIDGETS,
    "smart-initial-slides",
    "smart-screens",
] as const;

const WidgetList = () => {
    const [apps, setApps] = useAppsContext();
    return (
        <>
            {ALL_SMART_WIDGETS.map((widget) => (
                <Widget
                    name={widget}
                    apps={apps.filter((app) => app.widget === widget)}
                    key={widget}
                    label={WIDGET_LABELS[widget]}
                    setApps={setApps}
                />
            ))}
        </>
    );
};

const SmartEditorWrapper = (): JSX.Element => {
    return (
        <div className="smart-editor flex-grow-1 d-flex flex-column mt-5 bg-light m-2 p-3 position-relative">
            <h1>Smart Editor</h1>
            <div className="overflow-auto">
                <ErrorBoundary>
                    <RoleGroupsProvider>
                        <AppsProvider>
                            <WidgetList />
                        </AppsProvider>
                    </RoleGroupsProvider>
                </ErrorBoundary>
            </div>
        </div>
    );
};

export const SmartEditor = (): JSX.Element => (
    <Restricted access="SmartEditor">
        <SmartEditorWrapper />
    </Restricted>
);
